import { useEffect, useMemo, useState } from "react";
import { MaterialReactTable, MRT_Row, type MRT_ColumnDef, type MRT_SortingState } from 'material-react-table';
import dayjs from 'dayjs';
import { Badge, Box, Button, Grid, IconButton, Link, ListItemIcon, Menu, MenuItem, MenuProps, Paper, Tooltip, Typography, alpha, styled } from '@mui/material';
import assets from "../../../assets";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CssBaseline from '@mui/material/CssBaseline';
import { UserSessionStorageKey, UserSessionStorageModel, UserTableParameterStorageService } from "../../../services/sessionStorage";
import RefreshIcon from '@mui/icons-material/Refresh';
import colorConfigs from "../../../configs/colorConfigs";
import { Link as RouterLink } from 'react-router-dom';
import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import { tsXLXS } from 'ts-xlsx-export';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import { useMediaQuery } from '@mui/material';
import RareButton from "../buttons/RareButton";
import {
  MRT_ToggleGlobalFilterButton,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFullScreenButton,
} from 'material-react-table';

const StyledMenu = styled((props: any) => (
  <Menu data-testid="Menu-eib7"
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));


interface UsersTableProps {
  rows: any[];
  isLoading: boolean;
  sorting: any;
  columnVisibility: any;
  columnFilters: any;
  pagination: any;
  globalFilter: any;
  showGlobalFilter: any;
  setShowGlobalFilter: (value: any) => void;
  handleRemoveAllFilters: () => void;
  setGlobalFilter: (value: string) => void;
  setSorting: (sorting: any[]) => void;
  setColumnVisibility: (columnVisibility: { [key: string]: boolean }) => void;
  setColumnFilters: (filters: any[]) => void;
  setPagination: (pagination: { pageSize: number; pageIndex: number }) => void;
  setUser: (detail: any) => void;
  setPopup: (detail: any) => void;
  handleRefreshButton: () => void;
  openEditPage: (detail: any) => void;
  openCreatePage: () => void;
}

const UsersTable: React.FC<UsersTableProps> = ({
  rows,
  isLoading,
  sorting,
  columnVisibility,
  columnFilters,
  pagination,
  globalFilter,
  showGlobalFilter,
  setShowGlobalFilter,
  setGlobalFilter,
  handleRemoveAllFilters,
  setSorting,
  setColumnVisibility,
  setColumnFilters,
  setPagination,
  setUser,
  setPopup,
  handleRefreshButton,
  openEditPage,
  openCreatePage,
}) => {

  console.log("Users", rows)
  const isMobile = useMediaQuery('(max-width:768px)');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSaveFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: 'id',
      header: 'ID',
      Header: () => <div data-testid="div-5pus" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        ID<br />&nbsp;
      </div>,
    },
    {
      accessorKey: 'user_type',
      header: "User Type",
      Header: () => <div data-testid="div-u53j" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        User<br />Type
      </div>,
    },
    {
      accessorKey: 'first_name',
      header: 'First Name',
      Header: () => <div data-testid="div-2uzu" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        First<br />Name
      </div>,
    },
    {
      accessorKey: 'last_name',
      header: 'Last Name',
      Header: () => <div data-testid="div-cixs" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        Last<br />Name
      </div>,

    },
    {
      accessorKey: 'email',
      header: 'Email',
      Header: () => <div data-testid="div-a1r5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        Email<br />&nbsp;
      </div>,
    },
    {
      accessorFn: (row) => dayjs(row.date_joined).format('YYYY-MM-DD HH:mm:ss'),
      header: 'Created',
      Header: () => <div data-testid="div-rpcp" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        Created<br />&nbsp;
      </div>,
      Cell: ({ cell }) => (
        <div data-testid="div-m1nc" style={{ whiteSpace: 'pre-wrap' }}>
          {cell.getValue()?.toString().split(' ').join('\n')}
        </div>
      ),
    },
    {
      accessorFn: (row) => row.last_login ? dayjs(row.last_login).format('YYYY-MM-DD HH:mm:ss') : row.last_login,
      header: 'Last Login',
      Header: () => <div data-testid="div-opxg" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        Last<br />Login
      </div>,
      Cell: ({ cell }) => (
        <div data-testid="div-3d6b" style={{ whiteSpace: 'pre-wrap' }}>
          {cell.getValue()?.toString().split(' ').join('\n')}
        </div>
      ),
    },
    {
      accessorKey: 'is_active',
      header: 'Active',
      Header: () => <div data-testid="div-x61h" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '50px' }}>
        Active<br />&nbsp;
      </div>,
      Cell: ({ cell }) => (
        <div data-testid="div-w540" style={{ display: "flex", justifyContent: "center" }}>
          {cell.getValue()?.toString() == "true" ? <Typography data-testid="Typography-10y8" fontSize="smaller" sx={{ paddingX: 0.7, border: `1.5px solid ${colorConfigs.buttons.active}`, borderRadius: 2, color: colorConfigs.buttons.active }} >Active</Typography> : <Typography data-testid="Typography-vpg1" fontSize="smaller" sx={{ paddingX: 0.7, border: `1.5px solid ${colorConfigs.buttons.inactive}`, borderRadius: 2, color: colorConfigs.buttons.inactive }} >Inactive</Typography>}
        </div>
      ),
      filterVariant: 'checkbox',
    },
  ]


  // Define the type for the keys for handling persistance of table settings in session storage
  type UserSessionStorageKeyType = keyof UserSessionStorageModel;

  // Generic handler function for persisting table parameters
  const handleParameterChange = <T,>(
    key: UserSessionStorageKeyType,
    currentValue: T,
    setValueFunction: (value: T) => void,
    newValue: T | ((prevValue: T) => T)
  ) => {
    const updatedValue = typeof newValue === 'function' ? (newValue as (prevValue: T) => T)(currentValue) : newValue;
    UserTableParameterStorageService.set(key, updatedValue);
    setValueFunction(updatedValue);
  };

  // Handlers for persisting table: sorting, pagination, visibility, filter, search, and search bar visibility
  const setSortingFunction = (newSortingValue: any) =>
    handleParameterChange(UserSessionStorageKey.sorting, sorting, setSorting, newSortingValue);
  const setPaginationChangeFunction = (newPaginationValue: any) =>
    handleParameterChange(UserSessionStorageKey.pagination, pagination, setPagination, newPaginationValue);
  const setFilterChangeFunction = (newFilterChangeValue: any) =>
    handleParameterChange(UserSessionStorageKey.columnFilters, columnFilters, setColumnFilters, newFilterChangeValue);
  const setGlobalFilterChangeFunction = (newGlobalFilterChangeValue: string | ((prevValue: string) => string)) =>
    handleParameterChange(UserSessionStorageKey.search, globalFilter, setGlobalFilter, newGlobalFilterChangeValue);
  const setShowGlobalFilterChangeFunction = (newShowGlobalFilterChangeValue: any) =>
    handleParameterChange(UserSessionStorageKey.showSearch, showGlobalFilter, setShowGlobalFilter, newShowGlobalFilterChangeValue);


  return <MaterialReactTable
    columns={columns}
    data={rows}
    state={{
      isLoading,
      sorting,
      columnFilters,
      pagination,
      globalFilter,
      showGlobalFilter
    }}
    onSortingChange={setSortingFunction}
    onColumnFiltersChange={setFilterChangeFunction}
    onPaginationChange={setPaginationChangeFunction}
    onGlobalFilterChange={setGlobalFilterChangeFunction}
    onShowGlobalFilterChange={setShowGlobalFilterChangeFunction}
    defaultColumn={{
      minSize: 10,
      maxSize: 160,
      size: 10,
    }}
    enableColumnOrdering={true}
    positionActionsColumn="last"
    enableRowSelection
    selectAllMode="all"
    // enableRowActions
    initialState={{
      sorting,
      columnVisibility,
      columnFilters,
      pagination,
      globalFilter,
      density: 'compact',
      columnPinning: { left: ['mrt-row-select'], right: ['mrt-row-actions'] },
    }}

    // TABLE STYLING IS IN THE THEME
    displayColumnDefOptions={{
      'mrt-row-actions': {
        header: "Actions", // Renames Actions Column
      },
      'mrt-row-select': {
        visibleInShowHideMenu: false, //hide the built-in row actions column from the show hide menu
      },
    }}

    muiTopToolbarProps={({ table }) => ({
      sx: (theme: any) => ({
        ...((theme.components?.MuiCustomToolbar?.styleOverrides?.root) || {}),
      }),
    })}

    muiTableHeadProps={{
      sx: (theme: any) => theme.components?.MuiTableHead?.styleOverrides?.root || {},
    }}

    muiTableHeadCellProps={({ column }) => ({
      sx: (theme: any) => ({
        ...(theme.components?.MuiTableCell?.styleOverrides?.head || {}),
        ...(column.id === 'mrt-row-select' && {
          maxWidth: '50px',
          width: '50px',
        }),
      }),
    })}

    muiFilterTextFieldProps={{
      sx: (theme: any) => theme.components?.MuiFilterTextField?.styleOverrides?.root || {},
    }}

    muiTableBodyProps={{
      sx: (theme: any) => theme.components?.MuiTableBody?.styleOverrides?.root || {},
    }}

    muiPaginationProps={{
      rowsPerPageOptions: [250, 500, 1000],
      sx: {
        padding: 0,
        margin: 0,
        '& .MuiTablePagination-root': {
          padding: 0,
          margin: 0,
        },
        '& .MuiToolbar-root': {
          padding: 0,
          margin: 0,
          minHeight: '0px',
        },
        '& .MuiTablePagination-selectLabel': {
          margin: 0,
        },
        '& .MuiTablePagination-displayedRows': {
          margin: 0,
        },
        '& .MuiTablePagination-actions': {
          margin: 0,
        },
      },
    }}

    muiBottomToolbarProps={{
      // BOTTOM TOOLBAR (Pagination)
      sx: {
        height: '41px',
        maxHeight: '41px',
        minHeight: '41px',
        position: 'sticky',
        bottom: 0,
        zIndex: 1,
        backgroundColor: '#fff',
        boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)',
        margin: 0,
        padding: 0,
        '& .MuiToolbar-root': {
          padding: 0,
          margin: 0,
          paddingBottom: 0,
          paddingTop: 0,
        },
        '& .MuiBox-root': {
          p: 0,
        },
        '& .MuiIconButton-root': {
          color: colorConfigs.tables.headBg,
        },
        '& .MuiTablePagination-root': {
          margin: 0,
          paddingTop: 0.5,
          paddingBottom: 0.5,
          color: colorConfigs.buttons.bg,
        },
        '& .MuiTablePagination-selectLabel': {
          color: colorConfigs.tables.headBg,
          padding: 0,
          margin: 0,
        },
        '& .MuiTablePagination-displayedRows': {
          color: colorConfigs.buttons.bg,
          padding: 0,
          margin: 0,
        },
        '& .MuiTablePagination-actions': {
          color: colorConfigs.tables.headBg,
          padding: 0,
          margin: 0,
        },
      },
    }}

    muiSelectAllCheckboxProps={{
      'data-testid': 'Select-all-checkbox',
    } as any}

    muiSelectCheckboxProps={({ row }) => ({
      'data-testId': `Select-row-with-email-${row.original.email}`,
    } as any)}

    muiTableBodyRowProps={({ row }) => ({
      // slap the test‑id on here
      'data-testid': `Row-with-email-${row.original.email}`,

      // your existing handlers and styles
      onClick: (event: any) => {
        console.log(row.original);
        openEditPage(row);
      },
      sx: (theme: any) => ({
        ...(theme.components?.MuiTableBodyRow?.styleOverrides?.root || {}),
        backgroundColor:
          row.index % 2 === 0
            ? colorConfigs.tables.firstRow
            : colorConfigs.tables.secondRow,
      }),
    } as any)}

    muiTableBodyCellProps={({ cell, row }) => ({
      // this creates: e.g. id="email-cell-for-row-42"
      'data-testid': `${cell.column.id}-cell-for-row-with-email-${row.original.email}`,

      // preserve any other cell styles
      sx: {},
    } as any)}


    renderToolbarInternalActions={({ table }) => (
      <Box data-testid="Box-rvtn" sx={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
        {/* 1) Show/Hide Search */}
        <MRT_ToggleGlobalFilterButton
          table={table}
          data-testId={"Toggle-Search" as any}
          sx={{ py: 0.8, px: 1.5, border: '0.5px solid rgb(154, 148, 157)', borderRadius: '4px', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)" }}

        />

        {/* 2) Show/Hide Filters */}
        <MRT_ToggleFiltersButton
          table={table}
          data-testId={"Toggle-Filters" as any}
          sx={{ py: 0.8, px: 1.5, border: '0.5px solid rgb(154, 148, 157)', borderRadius: '4px', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)" }}

        />

        {/* 3) Show/Hide Columns */}
        <MRT_ShowHideColumnsButton
          table={table}
          data-testId={"Toggle-Columns" as any}
          sx={{ py: 0.8, px: 1.5, border: '0.5px solid rgb(154, 148, 157)', borderRadius: '4px', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)" }}
        />

        {/* 4) Show/Hide Density */}
        <MRT_ToggleDensePaddingButton
          table={table}
          data-testId={"Toggle-Density" as any}
          sx={{ py: 0.8, px: 1.5, border: '0.5px solid rgb(154, 148, 157)', borderRadius: '4px', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)" }}

        />

        {/* 5) Toggle Full Screen */}
        <MRT_ToggleFullScreenButton
          table={table}
          data-testId={"Toggle-Fullscreen" as any}
          sx={{ py: 0.8, px: 1.5, border: '0.5px solid rgb(154, 148, 157)', borderRadius: '4px', boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)" }}

        />
      </Box>
    )}

    renderTopToolbarCustomActions={({ table }) => {

      const handleArchiveCycles = () => {
        table.getSelectedRowModel().flatRows.map(row => {
          //Add archive logic
        });
      };

      const handleExportUserRows = (rows: any[]) => {
        const excelRows = [];
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
        const filename = `${now}_UserList`;

        for (let x = 0; x < rows.length; x++) {
          const user = rows[x].original;
          const formattedDateJoined = dayjs(user.date_joined).format('YYYY-MM-DD HH:mm:ss');
          const formattedLastLogin = user.last_login ? dayjs(user.last_login).format('YYYY-MM-DD HH:mm:ss') : '';

          excelRows[x] = {
            "ID": user.id,
            "User Type": user.user_type,
            "First Name": user.first_name,
            "Last Name": user.last_name,
            "Email": user.email,
            "Date Created": formattedDateJoined,
            "Last Login": formattedLastLogin,
            "Active": user.is_active ? "Yes" : "No",
          };
        }

        tsXLXS().exportAsExcelFile(excelRows).saveAsExcelFile(filename);
      };



      return (
        <Box data-testid="Box-agsf" sx={{ display: 'flex', gap: '0.3rem', height: "40px", alignItems: 'center' }}>
          <Tooltip data-testid="Tooltip-59t6" title="View action on selected data" placement="top" arrow>
            <Box data-testid="Box-6odx">
              <RareButton data-testid="RareButton-iykl"
                variant="outlined"
                onClick={handleClick}
                icon={<KeyboardArrowDownIcon sx={{ fontSize: isMobile ? '16px' : '24.5px', p: 0, m: 0, display: 'flex', alignItems: 'center' }} />}
                sx={{ gap: isMobile ? 0 : 1, px: isMobile ? 1 : 2, fontSize: '14px' }}
              >
                {isMobile ? "" : "Bulk Actions"}
              </RareButton>
            </Box>
          </Tooltip>
          <Tooltip data-testid="Tooltip-dude" title="Refresh Data" placement="top" arrow>
            <Box data-testid="Box-v6un">
              <RareButton data-testid="RareButton-j1iz"
                variant="outlined"
                onClick={() => handleRefreshButton()}
                center={true}
                icon={<RefreshIcon sx={{ fontSize: isMobile ? '16px' : '24.5px', p: 0, m: 0, display: 'flex', alignItems: 'center' }} />}
                sx={{ gap: 0, px: isMobile ? 1 : 2 }}
              >
              </RareButton>
            </Box>
          </Tooltip>
          <Tooltip data-testid="Tooltip-lvny" title="Clear All Table Filters" placement="top" arrow>
            <Box data-testid="Box-9ael">
              <RareButton data-testid="RareButton-gqid"
                variant="outlined"
                onClick={() => handleRemoveAllFilters()}
                icon={<FilterAltOffOutlinedIcon sx={{ fontSize: isMobile ? '16px' : '24.5px', p: 0, m: 0, display: 'flex', alignItems: 'center' }} />}
                sx={{ gap: 0, px: isMobile ? 1 : 2 }}
              >
              </RareButton>
            </Box>
          </Tooltip>
          <Tooltip data-testid="Tooltip-1dgb" title="Create New User" placement="top" arrow>
            <Box data-testid="Box-3y50">
              <RareButton data-testid="RareButton-xajw"
                onClick={openCreatePage}
                variant="success"
                icon={<GroupAddOutlinedIcon sx={{ fontSize: isMobile ? '16px' : '24.5px', p: 0, m: 0, display: 'flex', alignItems: 'center' }} />}
                sx={{ gap: isMobile ? 0 : 1, px: isMobile ? 1 : 2 }}
              >
                {isMobile ? "" : "Create User"}
              </RareButton>
            </Box>
          </Tooltip>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem data-testid="MenuItem-2k40" disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            } onClick={() => handleExportUserRows(table.getSelectedRowModel().rows)} disableRipple>
              Export to Excel
            </MenuItem>
          </StyledMenu>
        </Box>
      );
    }}

    renderRowActions={({ row, table }) => (

      <Box data-testid="Box-sgjp" sx={{ gap: '0.5rem', display: "flex" }}>
        {/* <Tooltip data-testid="Tooltip-ihdk"     
                    arrow
                    placement="left"
                    title="Cycles"
                    > */}
        <Badge data-testid="Badge-7p35"
          badgeContent={row.original.total_cycles}
          color={row.original.total_cycles ? 'primary' : 'default'}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '& .MuiBadge-badge': {
              top: '13px',
              right: '10px',
              background: colorConfigs.tables.headBg,
            },
          }}
          overlap="circular"
        >
          <IconButton data-testid="IconButton-x8rw"
            disabled={!row.original.total_cycles}
            component={RouterLink}
            to={`/cycles?user_id=${row.original.id}`}
            state={{ clinicID: row.original.id }}
            sx={{ transition: 'transform 0.3s ease' }}
          >
            <RotateRightOutlinedIcon fontSize="large" sx={{ color: row.original.total_cycles ? colorConfigs.sidebar.color : colorConfigs.sidebar.bg }} />
          </IconButton>
        </Badge>
        {/* </Tooltip> */}
      </Box>
    )}
  />
}

export default UsersTable;

